/*
*  Modal responsible for De-activating a device operator
*
* Copyright (C) 2018, 2019 Sterilis Solutions LLC all rights reserved.
*/
import React from 'react';
import { withTranslation as translate} from "react-i18next";
import {Trans} from "react-i18next";
import SimpleLoader from "./SimpleLoader";
import {Button, Header, Modal, TransitionablePortal} from "semantic-ui-react";
import AuthService from "./AuthService";
import * as Sentry from "@sentry/browser";

const Auth = new AuthService();

class DeleteOperatorModal extends React.Component {
  state = {
    allowModalToBeClosed: true,
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.setState({
      operatorBeingDeleted: this.props.operatorBeingDeleted
    })
  }

  deleteOperator = () => {
    const {operatorBeingDeleted} = this.state;
    const operatorBeingDeletedName = operatorBeingDeleted.employee.full_name;
    const operatorBeingDeletedEmployeeID = operatorBeingDeleted.employee.id;

    this.setState({appLoading: true, allowModalToBeClosed: false});
    Auth.fetch(`/api/employee/`+operatorBeingDeletedEmployeeID+'/', {
      method: 'DELETE',
    }).then(data => {
      this.setState({appLoading: false, allowModalToBeClosed: true});

      this.props.handleDeleteOperatorModal();
      this.props.fetchDeviceOperators();
      this.props.notifyOperatorDeactivationSuccess(operatorBeingDeletedName);
    }).catch(e => {
      Sentry.captureException(e);
      this.props.notifyOperatorDeactivationFailure(operatorBeingDeletedName);
      this.setState({appLoading: false, allowModalToBeClosed: true});
    });
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({width: window.innerWidth, height: window.innerHeight});
  };

  render() {
    // const topMargin = this.state.height < 1000 ? '3vh' : '10vh';
    const inlineStyle = {
      modal: {
        // marginTop: topMargin,
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '600px',
      },
      textArea: {
        marginTop: '50px',
        width: '400px'
      }
    };
    const {
      appLoading
    } = this.state;

    const {
      t,
      operatorBeingDeleted
    } = this.props;

    const operatorName = operatorBeingDeleted.employee.full_name;

    return (
      <TransitionablePortal
        open={this.props.showDeleteOperatorModal}
        onOpen={() => setTimeout(() => document.body.classList.add('modal-fade-in'), 0)}
        transition={{animation: 'scale', duration: 500}}
      >
        <Modal
          style={inlineStyle.modal}
          open={true}
          closeOnDimmerClick={this.state.allowModalToBeClosed}
          closeIcon={<Button className='close-modal-btn grey-btn'>{t('Close')}</Button>}
          onClose={(event) => {
            document.body.classList.remove('modal-fade-in');
            this.props.handleDeleteOperatorModal(operatorBeingDeleted)
          }}
        >
          {appLoading ? (
            <SimpleLoader/>
          ) : null}
          <Header>
            <h2 className='red'>{t('Archive Device Operator')}</h2>
          </Header>
          <Modal.Content className='create-device-operator-cust'>
            <div className='short-modal-text center-text'>
              <Trans ns="translations" i18nKey="deactivate-device-operator-prompt">
                Are you sure you want to archive {{operatorName}}'s device operator account?
              </Trans>
            </div>
            <div className='short-modal-text center-text'>
              <Trans ns='translations' i18nKey="deactivate-site-operator-dialogue">
                They will no longer be able to use their PIN to log into a Sterilis device.
              </Trans>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button className='red-btn submit-device-operators'
                    value="Submit"
                    type="submit"
                    id='deactivateOperator'
                    onClick={this.deleteOperator}
            >{t('Archive Device Operator')}</Button>
          </Modal.Actions>
        </Modal>
      </TransitionablePortal>
    )
  }
}

export default translate('translations')(DeleteOperatorModal);
